import moment from "moment";
import {
  GET_PROFESSIONAL_PROFILE,
  SET_PAGE,
  SET_SEARCH,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialProfessionalProfile = {
  professionalProfile: [],
  professionalProfileCount: 0,
  page: 1,
  search: "",
  sortby: "",
  orderby: "desc",
};

function professionalProfileReducer(
  state = initialProfessionalProfile,
  action
) {
  switch (action.type) {
    case GET_PROFESSIONAL_PROFILE:
      return {
        ...state,
        professionalProfile: action.payload.professionalProfile.map(
          (profile) => {
            return {
              ...profile,
              updatedAtFormatted: moment(profile.createdAt).format("ll"),
            };
          }
        ),
        professionalProfileCount: action.payload.totalCount,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    default:
      return state;
  }
}

export default professionalProfileReducer;
